import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Snack } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ui-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SnackbarComponent implements OnInit {
  bar$: Observable<Snack[]>;
  shown$: Observable<boolean>;

  constructor(private snackbarFacade: SnackbarFacade) {}

  ngOnInit(): void {
    this.bar$ = this.snackbarFacade.getSnackbar();
    this.shown$ = this.snackbarFacade.getSnackbarHidden().pipe(map((hidden: boolean) => !hidden));
  }
}
